export const CONTEXT_CACHE_EXPIRATION = 2592000000; //30 DAYS Temporary to be placed on ENV
